export function updateListTableHeaderSingle(state, array) {
  state.tableHeaderSingle = array;
}

export function updateListTableHeaderSingleOdnostoron(state, array) {
  state.tableHeaderSingleOdnostoron = array;
}
